import moment from "moment";

/** Mirrors Users::applyFeBookableDateFilters — bookable on D when onboarded and not past last day. */
export function isFeBookableOnDate(user, date = moment()) {
	if (!user) return false;
	const parsed = moment(date);
	const day = (date && parsed.isValid() ? parsed : moment()).format("YYYY-MM-DD");
	const onboard = user.onboarding_date
		? moment.parseZone(user.onboarding_date).format("YYYY-MM-DD")
		: null;
	const lastDay = user.last_day_working
		? moment.parseZone(user.last_day_working).format("YYYY-MM-DD")
		: null;
	if (onboard && onboard > day) return false;
	if (lastDay && lastDay < day) return false;
	return true;
}

export function feBookableTodayFilter(user) {
	return isFeBookableOnDate(user, moment());
}
